/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [{
  path: '/',
  // component: () => import('@/views/layouts/index'),
  component: () => import('@/components/DaxiMap'),
  // redirect: '/home',
  redirect: '/charge',
  meta: {
    title: '首页',
    keepAlive: false
  },
  children: [{
    path: '/index',
    name: 'Index',
    component: () => import('@/views/map/index'),
    meta: {
      title: '首页',
      keepAlive: true
    }
  }, {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/index'),
    meta: {
      title: 'Home',
      keepAlive: false,
      deepth: 0
    }
  }, {
    path: '/about',
    name: 'About',
    component: () => import('@/views/home/about'),
    meta: {
      title: '关于',
      keepAlive: false
    }
  }, {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/search/index'),
    meta: {
      title: '搜索',
      keepAlive: true
    }
  }, {
    path: '/searchDetails',
    name: 'SearchDetails',
    component: () => import('@/views/search/detail'),
    meta: {
      title: '搜索结果详情',
      keepAlive: false
    }
  }, {
    path: '/searchNavigation',
    name: 'SearchNavigation',
    component: () => import('@/views/search/navigation'),
    meta: {
      title: '搜索路线详情',
      keepAlive: false
    }
  }, {
    path: '/startNavigation',
    name: 'StartNavigation',
    component: () => import('@/views/search/startNavi'),
    meta: {
      title: '开始导航',
      keepAlive: false
    }
  }, {
    path: '/RouteDetail',
    name: 'RouteDetail',
    component: () => import('@/views/routeDetail/index'),
    meta: {
      title: '路线详情',
      keepAlive: false
    }
  }, {
    path: '/charge',
    name: 'charge',
    component: () => import('@/views/charge/index'),
    meta: {
      title: '充电车位',
      keepAlive: false
    }
  }]
}];